import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loot-box-item" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "coins" }
const _hoisted_8 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "text-capitalize-first" }

import StoreItemDTO from "@/models/StoreItemDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {computed} from "vue";
import {useStore} from "vuex";
import { AppEvents } from "@/models/enum/AppEvents";
import StoreLootBoxDTO from "@/models/StoreLootBoxDTO";
import MoneyDTO from "@/models/MoneyDTO";
import {useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'LootBoxBundle',
  props: {
    item: {},
    buyBtnDisabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const store = useStore();
const router = useRouter();

const buy = () => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }

  store.dispatch('emit', {event: AppEvents.SHOW_LOOT_BOX, data: props.item})
}
const lootBox = computed(() => {
  return props.item.content as StoreLootBoxDTO
})

const min = computed((): MoneyDTO => {
  return lootBox.value?.items[0].sum
})

const max = computed((): MoneyDTO => {
  return lootBox.value?.items[lootBox.value?.items.length - 1].sum
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: lootBox.value.iconUrl
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item.name), 1),
        _createElementVNode("div", _hoisted_7, [
          _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(min.value)) + " - " + _toDisplayString(_unref(numberFormatter).formatNumber(max.value)), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        disabled: _ctx.buyBtnDisabled,
        onClick: _withModifiers(buy, ["prevent"]),
        class: "btn btn-primary text-nowrap"
      }, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(numberFormatter).formatMoney(_ctx.item.price)), 1)
      ], 8, _hoisted_9)
    ])
  ]))
}
}

})